import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import "./Blog.css";
import Grid from "@mui/material/Grid";
import blogBanner from "../../../assets/blog-banner.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { GeneralFooter } from "../../../components";
import { allBlogs } from "../../../services";
import toast from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import defaultBlogImage from "../../../assets/default-blog.png";
import dayjs from "dayjs";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";

export const BlogPage = (props) => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_GENERAL_API_URL;
  const [blogs, setBlogs] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const getAllBlogs = async () => {
    const res = await allBlogs();
    if (res?.status === true) {
      setBlogs(res?.data);
      return;
    }
    toast.error("Something went wrong, please try again later.");
    setBlogs([]);
    return;
  };

  useEffect(() => {
    getAllBlogs();
  }, []);

  const extractContent = (s) => {
    var span = document.createElement("span");
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };

  const handleNavigate = (blog) => {
    navigate(`/blog-detail/${blog.id}`, {
      state: {
        blog,
      },
    });
    return;
  };

  return (
    <Box>
      {/* <CssBaseline /> */}
      <MooringMateHomeHeader />
      <Box className="page-title-section top-section" style={{ backgroundImage: `url(${blogBanner})` }}>
        <Box className="page-title-overlay"></Box>
        <Container maxWidth="lg">
          <h1 className="page-heading">Blog</h1>
        </Container>
      </Box>
      <Box>
        <Container maxWidth="lg">
          <Grid
            className="blog-list"
            container
            spacing={2}
            style={{ paddingTop: "80px", paddingBottom: "80px" }}
          >
            <Grid item md={12} style={{ width: '100%' }}>
              <h6 className="sub-title">Sailing into sustainability</h6>
              <h2 className="title">Explore eco-friendly yachting options</h2>
            </Grid>
            {blogs === null ? (
              <div className="loaderParent">
                <CircularProgress />
              </div>
            ) : (
              <>
                {blogs.length > 0 ? (
                  blogs.map((blog) => {
                    return (
                      <Grid item md={4} sm={6} xs={12}>
                        <Card>
                          <CardContent>
                            <img
                              alt="blog-image"
                              style={{
                                width: "100%",
                                height: "180px",
                                objectFit: "cover",
                                marginBottom: "20px",
                              }}
                              src={
                                blog?.imagePath
                                  ? `${baseUrl}/${blog?.imagePath}`
                                  : defaultBlogImage
                              }
                            />
                            <h3>{blog?.title}</h3>
                            <span className="date">
                              {dayjs(blog?.createdAt).format(
                                "YYYY-MM-DD  hh:mm A"
                              )}
                            </span>
                            <p>
                              {blog?.content.length > 200
                                ? `${extractContent(blog?.content).slice(
                                    0,
                                    200
                                  )}...`
                                : `${extractContent(blog?.content)}`}
                            </p>
                            <Button
                              className="btn-primary w-100"
                              type="submit"
                              variant="contained"
                              color="primary"
                              onClick={() => handleNavigate(blog)}
                            >
                              Read More
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })
                ) : (
                  <p style={{ textAlign: "center" }}>Blogs not available</p>
                )}
              </>
            )}
          </Grid>
        </Container>
      </Box>
      <GeneralFooter />
    </Box>
  );
};
